module.exports = __webpack_public_path__ + "img/img-4.13652570.png";